import { ELiveRecordFilter } from '@constants';
import { useTranslation } from 'react-i18next';

import { FiltersContainer, FilterButton } from './LiveRecordFilters.styles';

import { useLiveRecordFilterStore } from '@/store/events/useLiveRecordFilterStore';

type Props = {
  counts: { all: number; seen: number; not_seen: number };
};

export const LiveRecordFilters: React.FC<Props> = ({ counts }) => {
  const { filter, setFilter } = useLiveRecordFilterStore();
  const { t } = useTranslation('CourseTranslations');
  const onClick = (value: ELiveRecordFilter) => () => setFilter(value);

  return (
    <FiltersContainer>
      <FilterButton
        active={filter === ELiveRecordFilter.ALL}
        onClick={onClick(ELiveRecordFilter.ALL)}>
        {t('ALL_RECORDS', { count: counts.all })}
      </FilterButton>
      <FilterButton
        active={filter === ELiveRecordFilter.SEEN}
        onClick={onClick(ELiveRecordFilter.SEEN)}>
        {t('SEEN_RECORDS', { count: counts.seen })}
      </FilterButton>
      <FilterButton
        active={filter === ELiveRecordFilter.NOT_SEEN}
        onClick={onClick(ELiveRecordFilter.NOT_SEEN)}>
        {t('NOT_SEEN_RECORDS', { count: counts.not_seen })}
      </FilterButton>
    </FiltersContainer>
  );
};
